import types from './constant';
import * as reducerGenerators from './reducerGenerator';

const INITIAL_STATE = {
    list: [],
    current: null,
    loading: false
};

export default (state = INITIAL_STATE, action) => {
    if (reducerGenerators[action.type]) {
        return reducerGenerators[action.type](state, action);
    }
    return state;
};
